@if (isLoading()) {
  <div class="flex flex-col gap-6">
    <vx-skeleton class="h-10 w-72" />
    <vx-skeleton class="h-96 w-full" />
  </div>
} @else if (processor(); as processor) {
  <div class="flex flex-col gap-6">
    <div class="flex min-w-0 flex-col gap-1">
      <div class="flex min-w-0 items-center gap-3">
        <h1
          class="truncate font-brand text-3xl font-normal tracking-tight text-zinc-50">
          {{ processor.name }}
        </h1>
        @if (processor.isDefault) {
          <vx-badge tone="accent">
            {{
              'pages.settings.alerting.processors.details.defaultBadge'
                | transloco
            }}
          </vx-badge>
        }
      </div>
      <p class="text-sm tracking-tight text-zinc-400">
        {{
          'pages.settings.alerting.processors.totalAlertsProcessed' | transloco
        }}: {{ processor.statistics.totalAlertsProcessed }}
      </p>
    </div>

    <form [formGroup]="configurationFG" (ngSubmit)="save()" novalidate>
      <vx-card>
        <vx-card-header
          [title]="
            'pages.settings.alerting.processors.details.configuration.header'
              | transloco
          "
          [description]="
            'pages.settings.alerting.processors.details.configuration.description'
              | transloco
          " />

        <vx-panel variant="group">
          <div class="flex items-start justify-between gap-6">
            <div class="flex min-w-0 flex-col gap-0.5">
              <span class="text-sm font-medium tracking-tight text-zinc-100">
                {{
                  'pages.settings.alerting.processors.details.configuration.autoCreateIncidents'
                    | transloco
                }}
              </span>
              <span class="text-xs tracking-tight text-zinc-400">
                {{
                  'pages.settings.alerting.processors.details.configuration.autoCreateIncidentsHint'
                    | transloco
                }}
              </span>
            </div>
            <vx-switch
              formControlName="autoCreateIncidents"
              [ariaLabel]="
                'pages.settings.alerting.processors.details.configuration.autoCreateIncidents'
                  | transloco
              " />
          </div>
        </vx-panel>

        <vx-panel variant="group">
          <app-alert-configuration-wizard [configurationFG]="configurationFG" />
        </vx-panel>

        <vx-card-footer>
          <vx-button
            type="button"
            variant="outline"
            tone="secondary"
            [loading]="isSimulating()"
            [disabled]="configurationFG.enabled && configurationFG.invalid"
            (click)="simulate()">
            <vx-icon name="play" size="sm" />
            {{
              'pages.settings.alerting.processors.details.simulateAlertProcessorButton'
                | transloco
            }}
          </vx-button>
          <span
            vxCardFooterActions
            [vRequiredRoles]="['alertprocessors.manager']">
            <vx-button
              type="submit"
              [disabled]="!configurationFG.dirty || configurationFG.invalid"
              [loading]="isSaving()">
              {{
                'pages.settings.alerting.processors.details.saveAlertProcessorButton'
                  | transloco
              }}
            </vx-button>
          </span>
        </vx-card-footer>
      </vx-card>
    </form>

    <vx-card>
      <vx-card-header
        [title]="'components.dangerZone.header' | transloco"
        [description]="
          'pages.settings.alerting.processors.details.dangerZone.description'
            | transloco
        ">
        <div vxCardHeaderActions [vRequiredRoles]="['alertprocessors.manager']">
          <!-- tooltip on the wrapper: a disabled button swallows pointer events -->
          <span [vxTooltip]="deleteTooltip()">
            <vx-button
              tone="danger"
              [disabled]="processor.isDefault"
              (click)="deleteProcessor()">
              <vx-icon name="trash" size="sm" />
              {{
                'pages.settings.alerting.processors.details.deleteProcessorButton'
                  | transloco
              }}
            </vx-button>
          </span>
        </div>
      </vx-card-header>
    </vx-card>
  </div>
}
